/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  Component,
  Input,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  OnInit,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { DatePicker, DatePickerModule } from "primeng/datepicker";
import { ButtonModule } from "primeng/button";
import { SkeletonModule } from "primeng/skeleton";
import { SelectModule } from "primeng/select";
import { RevenueFiltersForm } from "../../interfaces/revenue-filters-form.interface";
import { CURRENCIES } from "../../../../core/constants/currencies";

@Component({
  selector: "app-date-filter",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DatePickerModule,
    ButtonModule,
    SkeletonModule,
    SelectModule,
  ],
  templateUrl: "./date-filter.component.html",
  styleUrl: "./date-filter.component.scss",
})
export class DateFilterComponent implements AfterViewInit, OnInit {
  @Input() formGroup!: FormGroup<RevenueFiltersForm>;
  @Input() drawerMode = false; // New drawer layout mode
  @Input() defaultCurrency = "USD"; // Default currency from site settings
  @Input() isLoading = false; // Loading state for skeleton
  @ViewChild("dateRangePicker") dateRangePicker?: DatePicker;

  // Currency options from core constants
  currencies = CURRENCIES;

  constructor(private cdr: ChangeDetectorRef) {}

  // Max date for date picker (today)
  maxDate: Date = new Date();

  /**
   * Initialize currency with default value from site
   */
  ngOnInit(): void {
    // Set initial currency from site's default if form doesn't have a value
    if (
      this.formGroup &&
      this.defaultCurrency &&
      !this.formGroup.controls.currency.value
    ) {
      this.formGroup.controls.currency.setValue(this.defaultCurrency);
    }
  }

  /**
   * Workaround for PrimeNG v19 display issue with range dates
   * Force update the datepicker after view initialization
   */
  ngAfterViewInit(): void {
    // Small delay to ensure the DatePicker is fully initialized
    setTimeout(() => {
      const currentValue = this.formGroup.controls.dateRange.value;
      if (
        this.dateRangePicker &&
        currentValue &&
        currentValue.length === 2 &&
        currentValue[0] &&
        currentValue[1]
      ) {
        // Force DatePicker to update its display by calling writeValue
        this.dateRangePicker.writeValue([...currentValue]);
        this.cdr.detectChanges();
      }
    }, 100);
  }

  /**
   * Handle date range selection - close overlay when both dates are selected
   * Workaround for PrimeNG v19 bug where hideOnDateTimeSelect doesn't work with range mode
   */
  onDateSelect(): void {
    const dateRange = this.formGroup.controls.dateRange.value;
    // Check if both dates in the range are selected
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      // Close the overlay
      this.dateRangePicker?.overlayVisible &&
        this.dateRangePicker.hideOverlay();
    }
  }

  // No @Output() needed!
  // No emitChange() needed!
  // Form automatically syncs with parent!
}
